import { observable } from 'mobx';

export type OrderItemPaymentResponseArgs = {
  id: number;
  order_item_id: number;
  payment_type: number;
};

export type OrderItemPaymentArgs = {
  id?: number;
  orderItemId?: number;
  paymentType?: number;
};

export const convertOrderItemPaymentResponseToArgs = (response: OrderItemPaymentResponseArgs) => {
  const args: OrderItemPaymentArgs = {
    id: response.id,
    orderItemId: response.order_item_id,
    paymentType: response.payment_type
  };
  return args;
};

export default class OrderItemPayment {
  @observable id?: number;
  @observable orderItemId?: number;
  @observable paymentType: number;

  constructor(args: OrderItemPaymentArgs) {
    this.id = args.id;
    this.orderItemId = args.orderItemId;
    this.paymentType = args.paymentType ?? 1;
  }

  get updateParams() {
    return {
      payment_type: this.paymentType
    };
  }

  isBulkTicket(): boolean {
    return this.paymentType === 3;
  }
}
